import { render, staticRenderFns } from "./WBtnNext.vue?vue&type=template&id=dd8024d4&scoped=true&"
import script from "./WBtnNext.vue?vue&type=script&lang=js&"
export * from "./WBtnNext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8024d4",
  null
  
)

export default component.exports